module.exports = __webpack_public_path__ + "img/screen-2-step-4.f7057b9f.png";